import axios from "axios";
import {useState} from "react";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ";
function PharmacyGSTBulkUpdate() {
    const [formData, setFormData] = useState({
        category: "",
        gst: "",
    });
    const [loading, setLoading] = useState(false);
    // HANDLE CHANGE
    const handleChange = (e) => {
        const {name, value} = e.target;
        // CATEGORY
        if (name === "category") {
            setFormData({
                ...formData,
                category: value,
            });
            return;
        }
        // GST FIELD
        if (
            value === "" ||
            /^\d{0,2}(\.\d{0,1})?$/.test(value)
        ) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };
    // BLOCK INVALID KEYS
    const handleKeyDown = (e) => {
        if (
            ["e", "E", "+", "-"].includes(e.key)
        ) {
            e.preventDefault();
        }
    };
    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.category) {
            Swal.fire({
                icon: "warning",
                title: "Select Category",
            });
            return;
        }
        if (!formData.gst) {
            Swal.fire({
                icon: "warning",
                title: "Enter GST %",
            });
            return;
        }
        try {
            setLoading(true);
            const _formData = new FormData();
            _formData.append(
                "category",
                formData.category
            );
            // SAME VALUE TO BOTH
            _formData.append(
                "sgst",
                formData.gst
            );
            _formData.append(
                "cgst",
                formData.gst
            );
            await axios.post(
                `${baseUrl}pharmacy-gst-update/`,
                _formData
            );
            Swal.fire({
                icon: "success",
                title: "GST Updated Successfully",
            });
            setFormData({
                category: "",
                gst: "",
            });
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Update Failed",
            });
        }
    };
    return (
        <section className="container mt-4">

            <div className="card shadow p-4">

                <h3 className="mb-4">
                    Pharmacy GST Update
                </h3>

                <form onSubmit={handleSubmit}>

                    {/* CATEGORY */}

                    <div className="mb-3">

                        <label className="form-label">
                            Medicine Category
                        </label>

                        <select
                            className="form-control"
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                        >

                            <option value="">
                                Choose Medicine Category
                            </option>

                            {/* Solid Dosage */}
                            <option value="Tablet">Tablet</option>
                            <option value="Capsule">Capsule</option>
                            <option value="Powder">Powder</option>
                            <option value="Granules">Granules</option>

                            {/* Liquid Dosage */}
                            <option value="Syrup">Syrup</option>
                            <option value="Suspension">Suspension</option>
                            <option value="Solution">Solution</option>
                            <option value="Drops">Drops</option>

                            {/* Injectable */}
                            <option value="Injection">Injection</option>

                            <option value="Infusion">
                                Infusion / IV Fluid
                            </option>

                            {/* Topical */}
                            <option value="Cream">Cream</option>
                            <option value="Ointment">Ointment</option>
                            <option value="Gel">Gel</option>
                            <option value="Lotion">Lotion</option>
                            <option value="Paste">Paste</option>

                            <option value="Dusting Powder">
                                Dusting Powder
                            </option>

                            {/* Inhalation */}
                            <option value="Inhaler">Inhaler</option>

                            <option value="Nebulizer Solution">
                                Nebulizer Solution
                            </option>

                            {/* Oral */}
                            <option value="Mouthwash">
                                Mouthwash
                            </option>

                            <option value="Gargle">
                                Gargle
                            </option>

                            <option value="Lozenges">
                                Lozenges
                            </option>

                            {/* Rectal */}
                            <option value="Suppository">
                                Suppository
                            </option>

                            <option value="Pessary">
                                Pessary
                            </option>

                            {/* Devices */}
                            <option value="Syringe">
                                Syringe
                            </option>

                            <option value="Needle">
                                Needle
                            </option>

                            <option value="IV Set">
                                IV Set
                            </option>

                            <option value="Cannula">
                                Cannula
                            </option>

                            <option value="Catheter">
                                Catheter
                            </option>

                            {/* Herbal */}
                            <option value="Ayurvedic">
                                Ayurvedic
                            </option>

                            <option value="Herbal">
                                Herbal
                            </option>

                            {/* Supplements */}
                            <option value="Protein Supplement">
                                Protein Supplement
                            </option>

                            <option value="Vitamin Supplement">
                                Vitamin Supplement
                            </option>

                            {/* Other */}
                            <option value="Vaccine">
                                Vaccine
                            </option>

                            <option value="Surgical Item">
                                Surgical Item
                            </option>

                            <option value="OTC Product">
                                OTC Product
                            </option>

                        </select>
                    </div>

                    {/* GST */}

                    <div className="mb-3">

                        <label className="form-label">
                            SGST / CGST %
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            style={{width: 120}}
                            name="gst"
                            value={formData.gst}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            step="0.1"
                        />

                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                    >

                        {
                            loading
                                ? "Updating..."
                                : "Update GST"
                        }

                    </button>

                </form>

            </div>

        </section>
    );
}
export default PharmacyGSTBulkUpdate;